import { useCallback } from 'react'

export interface AuthContextDependencies {
  unAuthorize: () => void
}

export function useAuthDependencies(): AuthContextDependencies {
  const unAuthorize = useCallback(() => {
    window.dispatchEvent(new CustomEvent('auth:unauthorized'))
  }, [])

  return {
    unAuthorize,
  }
}
